@if (documents$ | async; as documents) { @if (!isMobileView) {
<sco-dialog
  [icon]="'bi bi-clipboard-plus'"
  [title]="'DOWNLOAD_LIST' | translate"
  (scoDialogCloseClicked)="cancelDialog()">
  <div class="download-dialog-body two-column-layout">
    <!-- LINKER BEREICH -->
    <div class="download-list-section" [class.download-list-inactive]="isDownloadActive$ | async">
      <div class="header">
        <span class="title">{{ 'DOCUMENTS' | translate }}</span>
        <!--
              <sco-chips title="{{ 'ALL' | translate }}" variant="action" (click)="setFormatFilter('ALL')"></sco-chips>
              <sco-chips title="PDF" variant="action" (click)="setFormatFilter('PDF')"></sco-chips>
              <sco-chips title="WORD" variant="action" (click)="setFormatFilter('WORD')"></sco-chips>
              -->
        <button scoButton variant="link" [disabled]="documents.length === 0" (click)="onClearDownloadList()">
          <i class="bi bi-trash"></i> {{ 'REMOVE_ALL' | translate }}
        </button>
      </div>
      @if (documents.length === 0) {
      <sco-infobox icon="bi bi-info-circle" message="{{ 'DOWNLOAD_LIST_EMPTY' | translate }}"> </sco-infobox>
      } @if (documents.length > 0) {
      <div class="download-list-wrapper">
        <div cdkDropList [cdkDropListData]="sortedDocuments" (cdkDropListDropped)="drop($event)">
          @for (docu of sortedDocuments; track trackByDocumentId(i, docu); let i = $index) {
          <div class="download-item" (click)="onDocumentSelected(docu)" cdkDrag>
            <i class="bi bi-grip-vertical smaller-icon drag-icon" cdkDragHandle (click)="$event.stopPropagation()"></i>
            <img class="thumbnail" [src]="docu.coverUrl || 'assets/img/thumbnail-placeholder.png'" alt="cover" />
            <div class="attachment-main">
              <span class="dl-related-content-title" [scoTooltip]="docu.title" [dcOnlyIfTruncated]="true">
                @if (docu.type === 'chapter') { [{{ 'CHAPTER' | translate }} "{{ docu.chapterName }}"].
                {{ docu.title }} } @if (docu.type !== 'chapter') { @if (docu.start_page_nr || docu.end_page_nr) { [{{
                  'PAGE' | translate
                }}
                {{ docu.start_page_nr }}@if (docu.end_page_nr) { -{{ docu.end_page_nr }}
                }]. }
                {{ docu.title }}
                }
              </span>
              <div class="attachment-meta">
                @if (docu.type !== 'asset' && docu.type !== 'page') {
                <span class="attachment-badge">{{ docu.language }}</span>
                }
                <span class="attachment-badge">{{ docu.extension }}</span>
                <span class="attachment-badge">
                  @if (docu.type === 'asset') {
                  <span>~</span>
                  }
                  {{ docu.size }} MB
                </span>
              </div>
            </div>
            <div class="attachment-actions">
              <i
                class="bi bi-trash smaller-icon meta-information-icon"
                (click)="
                  onRemoveFromDownloadList(docu.documentId, docu.start_page, docu.end_page, docu.assetId);
                  $event.stopPropagation()
                "></i>
              <!--
                      <i class="bi bi-three-dots-vertical smaller-icon meta-information-icon"></i>
                      -->
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
    <!-- TRENNLINIE -->
    <div class="vertical-divider"></div>
    <!-- RECHTER BEREICH -->
    <div
      class="options-section-wrapper"
      [class.download-active]="isDownloadActive$ | async"
      [class.download-list-inactive]="documents.length === 0">
      <div class="options-title">
        <i class="bi bi-gear"></i>
        <span>{{ 'DOWNLOAD_LIST_OPTIONS' | translate }}</span>
      </div>
      <div class="options-section">
        <div class="option">
          <label class="radio-option">
            <input type="radio" name="downloadType" [(ngModel)]="downloadMode" [value]="'zip'" />
            <span>{{ 'DOWNLOAD_AS_ZIP' | translate }}</span>
          </label>
          @if (downloadMode === 'zip') {
          <div class="name-input-wrapper">
            <label for="zipName" class="name-input-label">{{ 'ZIP_NAME' | translate }}</label>
            <input
              id="zipName"
              type="text"
              [(ngModel)]="inputName"
              required
              placeholder="{{ 'DOWNLOAD_LIST_INPUT_PLACEHOLDER' | translate }}"
              class="name-input" />
          </div>
          }
          <label class="radio-option" [class.radio-option-disabled]="(hasOnlyPdfDocuments$ | async) === false">
            <input
              type="radio"
              name="downloadType"
              [(ngModel)]="downloadMode"
              [value]="'merged_pdf'"
              [disabled]="(hasOnlyPdfDocuments$ | async) === false" />
            <span>{{ 'DOWNLOAD_AS_MERGED_PDF' | translate }}</span>
          </label>
          @if (downloadMode === 'merged_pdf') {
          <div class="name-input-wrapper">
            <label for="mergedPdfName" class="name-input-label">{{ 'PDF_NAME' | translate }}</label>
            <input
              id="mergedPdfName"
              type="text"
              [(ngModel)]="inputName"
              required
              placeholder="{{ 'DOWNLOAD_LIST_INPUT_PLACEHOLDER' | translate }}"
              class="name-input" />
          </div>
          }
          <div class="clear-after-download-wrapper">
            <sco-checkbox
              [size]="'small'"
              [text]="'CLEAR_DOWNLOAD_LIST_AFTER_DOWNLOAD' | translate"
              [isChecked]="clearAfterDownload"
              [disabled]="false"
              [isError]="false"
              (changeAction)="onClearDownloadListCheckboxChange()">
            </sco-checkbox>
          </div>
          <div class="flex flex-col gap-2">
            @if (downloadMode === 'merged_pdf') {
            <sco-infobox icon="bi bi-info-circle" message="{{ 'DOWNLOAD_LIST_PDF_INFO_TEXT' | translate }}">
            </sco-infobox>
            } @if ((hasOnlyPdfDocuments$ | async) === false && documents.length > 0) {
            <sco-infobox icon="bi bi-info-circle" message="{{ 'DOWNLOAD_LIST_ONLY_PDFS_HINT' | translate }}">
            </sco-infobox>
            } @if (getTotalSize(documents) >= getMaxTotalSize()) {
            <sco-infobox
              icon="bi bi-exclamation-triangle"
              variant="warning"
              [message]="
                ('DOWNLOAD_LIST_LIMITATION_WARNING_START' | translate) +
                ' (' +
                getMaxTotalSize() +
                ' MB). ' +
                ('DOWNLOAD_LIST_LIMITATION_WARNING_END' | translate)
              "></sco-infobox>
            }
          </div>
        </div>
      </div>
      @if (isDownloadActive$ | async) {
      <div class="dialog-block-overlay">
        <div class="download-overlay-content">
          <sco-loading-indicator size="large"></sco-loading-indicator>
          <strong>{{ 'DOWNLOAD_PREPARING_TITLE' | translate }}</strong>
          <span>{{ 'DOWNLOAD_PREPARING_TEXT' | translate }}</span>
        </div>
      </div>
      }
    </div>
  </div>
  <!-- FOOTER -->
  @if (documents.length > 0) {
  <ng-container footerLeft>
    <div class="h-full content-center gap-2 flex">
      @if (filteredCount > 0) {
      <sco-chips
        variant="display"
        title="
              {{ filteredCount }} {{ filteredCount === 1 ? ('FILE' | translate) : ('FILES' | translate) }}
            "></sco-chips>
      } @if (filteredCount > 0) {
      <sco-chips
        variant="display"
        [state]="
          getTotalSize(documents) >= getMaxTotalSize()
            ? 'error'
            : getTotalSize(documents) >= getWarningTotalSize()
            ? 'warning'
            : 'default'
        "
        [title]="getTotalSize(documents).toFixed(2) + ' MB'">
      </sco-chips>
      }
    </div>
  </ng-container>
  }
  <ng-container footerRight>
    <button
      scoButton
      (click)="onDownloadButtonClick()"
      [disabled]="
        (isDownloadActive$ | async) === false &&
        (documents.length === 0 || getTotalSize(documents) >= getMaxTotalSize())
      "
      variant="primary">
      @if ((isDownloadActive$ | async) === true) {
      <i class="bi bi-x-lg"></i>
      {{ 'CANCEL_DOWNLOAD' | translate }}
      } @else {
      <i class="bi bi-download"></i>
      {{ 'DOWNLOAD' | translate }}
      }
    </button>
  </ng-container>
</sco-dialog>
}
<!-- MOBILE VIEW -->
@if (isMobileView) {
<div class="download-list-dialog-mobile-wrapper">
  <div class="mobile-header">
    <div class="mobile-header-title">
      <i class="bi bi-clipboard-plus"></i>
      <span class="title">{{ 'DOWNLOAD_LIST' | translate }}</span>
    </div>
    <button scoButton variant="link" [onlyIcon]="true" (click)="cancelDialog()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div class="mobile-download-list-scroll" [class.download-list-inactive]="isDownloadActive$ | async">
    <div class="download-list-section">
      <div class="header">
        <span class="title">{{ 'DOCUMENTS' | translate }}</span>
        <button
          scoButton
          variant="link"
          [onlyIcon]="true"
          [disabled]="documents.length === 0"
          (click)="onClearDownloadList()">
          <i class="bi bi-trash"></i>
        </button>
      </div>
      @if (documents.length === 0) {
      <sco-infobox icon="bi bi-info-circle" message="{{ 'DOWNLOAD_LIST_EMPTY' | translate }}"> </sco-infobox>
      } @if (documents.length > 0) {
      <div cdkDropList [cdkDropListData]="sortedDocuments" (cdkDropListDropped)="drop($event)">
        @for (docu of sortedDocuments; track trackByDocumentId(i, docu); let i = $index) {
        <div class="download-item" (click)="onDocumentSelected(docu)" cdkDrag>
          <i class="bi bi-grip-vertical smaller-icon drag-icon" cdkDragHandle (click)="$event.stopPropagation()"></i>
          <img class="thumbnail" [src]="docu.coverUrl || 'assets/img/thumbnail-placeholder.png'" alt="cover" />
          <div class="attachment-main">
            <span class="dl-related-content-title" [scoTooltip]="docu.title" [dcOnlyIfTruncated]="true">
              @if (docu.type === 'chapter') { [{{ 'CHAPTER' | translate }} "{{ docu.chapterName }}"]. {{ docu.title }}
              } @if (docu.type !== 'chapter') {
              {{ docu.title }}
              }
            </span>
            <div class="attachment-meta">
              @if (docu.type !== 'asset' && docu.type !== 'page') {
              <span class="attachment-badge">{{ docu.language }}</span>
              }
              <span class="attachment-badge">{{ docu.extension }}</span>
              <span class="attachment-badge">
                @if (docu.type === 'asset') {
                <span>~</span>
                }
                {{ docu.size }} MB
              </span>
            </div>
          </div>
          <div class="attachment-actions">
            <i
              class="bi bi-trash smaller-icon meta-information-icon"
              (click)="
                onRemoveFromDownloadList(docu.documentId, docu.start_page, docu.end_page, docu.assetId);
                $event.stopPropagation()
              "></i>
            <!--
                          <i class="bi bi-three-dots-vertical smaller-icon meta-information-icon"></i>
                          -->
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
  <div class="mobile-download-footer">
    @if (documents.length > 0) {
    <div class="mobile-download-footer-options">
      <div class="footer-toggle" (click)="toggleOptions()">
        <div class="options-title">
          <i class="bi bi-gear"></i>
          <span>{{ 'DOWNLOAD_LIST_OPTIONS' | translate }}</span>
        </div>
        <i class="bi" [ngClass]="{ 'bi-chevron-down': isOptionsOpen, 'bi-chevron-up': !isOptionsOpen }"></i>
      </div>
      <div
        [ngClass]="{ 'options-section-wrapper-mobile': true, open: isOptionsOpen }"
        [class.download-active]="isDownloadActive$ | async">
        <div class="options-section" [ngClass]="{ hidden: !isOptionsOpen }">
          <label class="radio-option">
            <input type="radio" name="downloadTypeMobile" [(ngModel)]="downloadMode" [value]="'zip'" />
            <span>{{ 'DOWNLOAD_AS_ZIP' | translate }}</span>
          </label>
          @if (downloadMode === 'zip') {
          <div class="name-input-wrapper">
            <label for="zipNameMobile" class="name-input-label">{{ 'ZIP_NAME' | translate }}</label>
            <input
              id="zipNameMobile"
              type="text"
              [(ngModel)]="inputName"
              required
              placeholder="{{ 'DOWNLOAD_LIST_INPUT_PLACEHOLDER' | translate }}"
              class="name-input" />
          </div>
          }
          <label class="radio-option" [class.radio-option-disabled]="(hasOnlyPdfDocuments$ | async) === false">
            <input
              type="radio"
              name="downloadTypeMobile"
              [(ngModel)]="downloadMode"
              [value]="'merged_pdf'"
              [disabled]="(hasOnlyPdfDocuments$ | async) === false" />
            <span>{{ 'DOWNLOAD_AS_MERGED_PDF' | translate }}</span>
          </label>
          @if (downloadMode === 'merged_pdf') {
          <div class="name-input-wrapper">
            <label for="mergedPdfNameMobile" class="name-input-label">{{ 'PDF_NAME' | translate }}</label>
            <input
              id="mergedPdfNameMobile"
              type="text"
              [(ngModel)]="inputName"
              required
              placeholder="{{ 'DOWNLOAD_LIST_INPUT_PLACEHOLDER' | translate }}"
              class="name-input" />
          </div>
          }
          <div class="clear-after-download-wrapper">
            <sco-checkbox
              [size]="'small'"
              [text]="'CLEAR_DOWNLOAD_LIST_AFTER_DOWNLOAD' | translate"
              [isChecked]="clearAfterDownload"
              [disabled]="false"
              [isError]="false"
              (changeAction)="onClearDownloadListCheckboxChange()">
            </sco-checkbox>
          </div>
          @if (downloadMode === 'merged_pdf') {
          <sco-infobox icon="bi bi-info-circle" message="{{ 'DOWNLOAD_LIST_PDF_INFO_TEXT' | translate }}">
          </sco-infobox>
          } @if ((hasOnlyPdfDocuments$ | async) === false && documents.length > 0) {
          <sco-infobox icon="bi bi-info-circle" message="{{ 'DOWNLOAD_LIST_ONLY_PDFS_HINT' | translate }}">
          </sco-infobox>
          } @if (getTotalSize(documents) >= getMaxTotalSize()) {
          <sco-infobox
            class="mt-[var(--sco-spacing-8)]"
            icon="bi bi-exclamation-triangle"
            variant="warning"
            [message]="
              ('DOWNLOAD_LIST_LIMITATION_WARNING_START' | translate) +
              ' (' +
              getMaxTotalSize() +
              ' MB). ' +
              ('DOWNLOAD_LIST_LIMITATION_WARNING_END' | translate)
            "></sco-infobox>
          }
        </div>
        @if (isDownloadActive$ | async) {
        <div class="dialog-block-overlay">
          <div class="download-overlay-content">
            <sco-loading-indicator size="large"></sco-loading-indicator>
            <strong>{{ 'DOWNLOAD_PREPARING_TITLE' | translate }}</strong>
            <span>{{ 'DOWNLOAD_PREPARING_TEXT' | translate }}</span>
          </div>
        </div>
        }
      </div>
    </div>
    }
    <div class="mobile-footer-buttons">
      <div class="h-full content-center gap-2 flex">
        @if (filteredCount > 0) {
        <sco-chips
          variant="display"
          title="
                {{ filteredCount }} {{ filteredCount === 1 ? ('FILE' | translate) : ('FILES' | translate) }}
            "></sco-chips>
        } @if (filteredCount > 0) {
        <sco-chips variant="display" [title]="getTotalSize(documents).toFixed(2) + ' MB'"></sco-chips>
        }
      </div>
      <button
        scoButton
        (click)="onDownloadButtonClick()"
        [disabled]="
          (isDownloadActive$ | async) === false &&
          (documents.length === 0 || getTotalSize(documents) >= getMaxTotalSize())
        "
        variant="primary">
        @if ((isDownloadActive$ | async) === true) {
        <i class="bi bi-x-lg"></i>
        {{ 'CANCEL_DOWNLOAD' | translate }}
        } @else {
        <i class="bi bi-download"></i>
        {{ 'DOWNLOAD' | translate }}
        }
      </button>
    </div>
  </div>
</div>
} }
